module.exports = __webpack_public_path__ + "img/voyage.87bd43d4.svg";